import { api } from '@/fsd/shared/api';
import { IGetActiveTariffResponse } from '../../model/types/IGetActiveTariffResponse';

export const getActiveTariff =
  async (): Promise<IGetActiveTariffResponse | null> => {
    try {
      const data = await api.get<IGetActiveTariffResponse>(
        '/api/v1/payment/active-tariff/',
        {
          notify: {
            error: false,
          },
        }
      );

      return data;
    } catch (e) {
      console.error('Ошибка при получении активного тарифа:', e);
      return null;
    }
  };
